// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--25u8h","fade":"fade--kBsAx","icon":"icon--sQS2J","childrenWrapper":"childrenWrapper--mcVCO"};